import { Outlet } from '@remix-run/react'

export const handle = {
	breadcrumb: 'Data Display',
}

const LayoutRoute = () => {
	return <Outlet />
}
export default LayoutRoute
